import {createSvgIcon} from './utils'

export default createSvgIcon(
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.5 21C16.2991 21 21 16.2991 21 10.5C21 4.70085 16.2991 0 10.5 0C4.70085 0 0 4.70085 0 10.5C0 16.2991 4.70085 21 10.5 21ZM15.3925 6.56369C15.183 6.38065 14.9094 6.28824 14.6317 6.30675C14.3542 6.32525 14.0953 6.45316 13.912 6.66239L9.16911 12.3901L7.07332 9.79139C6.88264 9.59719 6.624 9.48461 6.35193 9.47739C6.07987 9.47018 5.81562 9.56889 5.61492 9.75271C5.41421 9.93654 5.29272 10.1911 5.27607 10.4628C5.25941 10.7344 5.34888 11.0019 5.52562 11.2089L8.01727 14.1751C8.29925 14.4833 8.68503 14.7354 9.16911 14.7354C9.7188 14.7354 10.277 14.4369 10.4995 14.1751C10.722 13.9133 15.4912 8.04524 15.4912 8.04524C15.6743 7.83587 15.7669 7.56236 15.7486 7.28478C15.7303 7.00721 15.6015 6.74719 15.3925 6.56369Z"
  />,
  'CheckPinBadge',
)
